import { render, staticRenderFns } from "./saftyDesignDoc.vue?vue&type=template&id=73744dea"
import script from "./saftyDesignDoc.vue?vue&type=script&lang=js"
export * from "./saftyDesignDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73744dea')) {
      api.createRecord('73744dea', component.options)
    } else {
      api.reload('73744dea', component.options)
    }
    module.hot.accept("./saftyDesignDoc.vue?vue&type=template&id=73744dea", function () {
      api.rerender('73744dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/smi/saftyDesignDoc.vue"
export default component.exports